// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Button from "components/base/Button";

// #####################################################

export const StyledPanelNav = styled(Button)`
	display: block;
	flex: 1;
	padding: 1rem;
	border-radius: var(--dz-ref-border-radius-1-75);
	border-bottom-right-radius: 0;
	border-bottom-left-radius: 0;
	font-size: 1.25rem;
	font-weight: bold;
	color: var(--dz-comp-auth-panel-text-color);
	text-align: center;

	&:first-child {
		border-top-right-radius: 0;
	}
	&:last-child {
		border-top-left-radius: 0;
	}

	text-overflow: ellipsis;
	overflow: hidden;

	&.selected {
		background-color: var(--dz-comp-auth-panel-background-color-selected);
	}

	&:not(.selected) {
		background-color: var(
			--dz-comp-auth-panel-background-color-not-selected
		);
		border-bottom: 1px solid var(--dz-comp-auth-panel-border-color);
		${({ isRegister }) =>
			isRegister
				? css`
						border-left: 1px solid
							var(--dz-comp-auth-panel-border-color);
				  `
				: css`
						border-right: 1px solid
							var(--dz-comp-auth-panel-border-color);
				  `}
	}

	&:not(.selected):hover {
		background-color: var(
			--dz-comp-auth-panel-background-color-not-selected-hover
		);
	}
`;

// #####################################################
